module.exports = __webpack_public_path__ + "static/media/plan-b-icon.05e1be85.png";